import React from "react";
import { Bell, Package, Truck, CreditCard } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

const notificationIcons = {
  new_delivery: Package,
  delivery_update: Truck,
  new_booking: Package,
  payment_received: CreditCard,
};

/**
 * Single notification row item
 */
export function NotificationItem({ notification, onClick }) {
  const Icon = notificationIcons[notification.type] || Bell;
  
  return (
    <div
      onClick={() => onClick(notification)}
      className={`p-3 border-b border-border cursor-pointer hover:bg-secondary/50 transition-colors ${
        !notification.read ? "bg-primary/5" : ""
      }`}
    >
      <div className="flex gap-3">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
          !notification.read ? "bg-primary/20" : "bg-secondary"
        }`}>
          <Icon className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-sm ${!notification.read ? "font-semibold" : ""}`}>
            {notification.title}
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {notification.message}
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
          </p>
        </div>
        {!notification.read && (
          <div className="w-2 h-2 rounded-full bg-primary mt-2" />
        )}
      </div>
    </div>
  );
}
